<div id="reciept-print" *ngIf="config && !loading">
  <div class="reciept">
    <div class="restaurant-detail text-center">
      <p class="title">فاتورة ضريبية</p>
      <div class="img-card" *ngIf="config.RestaurantLogo?.isActive">
        <img [src]="logo || config.RestaurantLogo.value" alt="">
      </div>
      <div class="rest-name font-16 font-medium">
        {{orderDetails.restaurantName}}
      </div>
      <div class="res-address font-12 font-light"
        *ngIf="config.RestaurantAddress?.isActive">
        {{orderDetails.restaurantAddress}}
      </div>
    </div>

    <div class="order-detail">

      <div class="order-no font-14 font-medium text-center">
        الرقم الضريبي: {{orderDetails.restaurantVatNumber}}</div>

      <table class="reserv-details">
        <tr>
          <td>
            <div class="order-no font-14 font-medium text-center">
              رقم الطلب #{{orderDetails.orderNumber}}</div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="order-no font-14 font-medium text-center">
              رقم الفاتورة #{{orderDetails.orderId}}</div>
          </td>
        </tr>
      </table>

      <div class="order-time font-12 font-light text-center">
        <!-- {{paymentDetails.paidAt | date:'EEEE, d MMMM, y h:mm:ss a'}} -->
        {{paymentDetails.paidAt | date:'y-MM-d, h:mm:ss a'}}
      </div>

      <table class="reserv-details font-12 font-light">
        <tr>
          <td *ngIf="config.TableNames?.isActive">
            <span>رقم الطاولة: </span>
            <span class="font-medium">{{orderDetails.tableName}}</span>
          </td>
          <td *ngIf="config.WaiterName?.isActive" class="text-right">
            <span>النادل: </span>
            <span class="font-medium">{{orderDetails.waiterName}}</span>
          </td>
        </tr>
      </table>

      <table class="guest-detail font-12 font-light" *ngIf="config.GuestName?.isActive">
        <tr>
          <td>
            <span>اسم الضيف: </span>
            <span class="font-medium">{{orderDetails.customerName}}</span>
          </td>
          <td class="text-right">
            <span>عدد الضيوف: </span>
            <span class="font-medium">{{orderDetails.partySize}}</span>
          </td>
        </tr>
      </table>

      <table class="order-items font-12 font-light">
        <tr class="text-uppercase">
          <td>الكمية</td>
          <td class="">العناصر</td>
          <td class="text-right" *ngIf="config.ItemPrice?.isActive">السعر</td>
          <td class="text-right">المجموع</td>
        </tr>
        <ng-container *ngFor="let item of orderDetails.orderItems">
          <tr>
            <td>
              {{item.quantity}}
              <div *ngIf="item.freeQuantity">({{item.freeQuantity}} مجاني)</div>
            </td>
            <td>{{item.itemName}} ({{item.sizeName}})</td>
            <td class="text-right" *ngIf="config.ItemPrice?.isActive">{{item.price}}</td>
            <td class="text-right">{{item.totalItemprice}}</td>
          </tr>
          <ng-container *ngIf="item.additions?.length">
            <ng-container *ngFor="let o of item.additions">
              <tr><td></td><td class="font-medium">{{o.name}}</td><td></td><td></td></tr>
              <tr *ngFor="let i of o.itemAdditionlist">
                <td></td>
                <td>{{i.name}}</td>
                <td class="text-right">{{i.price}}</td>
                <td></td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="item.variants?.length">
            <ng-container *ngFor="let o of item.variants">
              <tr><td></td><td class="font-medium">{{o.name}}</td><td></td><td></td></tr>
              <tr *ngFor="let i of o.itemVariantlist">
                <td></td>
                <td>{{i.name}}</td>
                <td class="text-right">{{i.price}}</td>
                <td></td>
              </tr>
            </ng-container>
          </ng-container>

        </ng-container>
      </table>

      <div class="seperator"></div>

      <ng-container *ngIf="config.TotalPrice?.isActive">
        <table class="total-price font-12 font-light">
          <tr *ngIf="paymentDetails.priceDetails.surchargeValue">
            <td>تكلفة إضافية</td>
            <td class="text-right">+{{paymentDetails.priceDetails.surchargeValue}} {{orderDetails.currency?.currencyCode}}</td>
          </tr>
          <tr *ngIf="paymentDetails.priceDetails.discountValue">
            <td>خصم</td>
            <td class="text-right">-{{paymentDetails.priceDetails.discountValue}} {{orderDetails.currency?.currencyCode}}</td>
          </tr>
          <tr *ngIf="paymentDetails.priceDetails.deposit">
            <td>إيداع الحجز</td>
            <td class="text-right">-{{paymentDetails.priceDetails.deposit}} {{orderDetails.currency?.currencyCode}}</td>
          </tr>
          <tr>
            <td>ضريبة القيمة المضافة</td>
            <td class="text-right">{{paymentDetails.priceDetails.taxValue}} {{orderDetails.currency?.currencyCode}}</td>
          </tr>
        </table>

        <div class="price-sep"></div>

        <table class="font-12 font-light">
          <tr>
            <td class="font-medium">المجموع شامل ضريبة القيمة المضافة:</td>
            <td class="text-right">{{paymentDetails.priceDetails.subTotal}} {{orderDetails.currency?.currencyCode}}</td>
          </tr>
        </table>
      </ng-container>

      <div class="price-sep"></div>

      <table class="total-price font-12 font-light" *ngIf="paymentDetails.priceDetails.serviceValue">
        <tr>
          <td>قيمة الخدمة</td>
          <td class="text-right">
            {{paymentDetails.priceDetails.serviceValue}} {{orderDetails.currency?.currencyCode}}
          </td>
        </tr>
        <tr>
          <td>الإجمالي</td>
          <td class="text-right">{{paymentDetails.priceDetails.total}} {{orderDetails.currency?.currencyCode}}</td>
        </tr>
      </table>

      <div class="portion font-12 font-light" *ngIf="paymentDetails.isPortion">
        هذا جزء من إجمالي مبلغ الطلب.
      </div>

      <table class="payment-method font-12 font-light" *ngIf="config.PaymentMethod?.isActive">
        <tr>
          <td>طريقة الدفع</td>
          <td class="text-right">المدفوع</td>
        </tr>
        <tr class="font-medium">
          <td *ngIf="paymentDetails.paymentOption == 'Cash'">نقدي</td>
          <td *ngIf="paymentDetails.paymentOption == 'CreditCard' || paymentDetails.paymentOption == 'Mada'">بطاقة (تنتهي بـ ** {{paymentDetails.cardLastNumbers}})</td>
          <td *ngIf="paymentDetails.paymentOption != 'Cash' && paymentDetails.paymentOption != 'CreditCard' && paymentDetails.paymentOption != 'Mada'">{{paymentDetails.paymentOptionName}}</td>
          <td class="text-right">{{paymentDetails.paidPrice}} {{orderDetails.currency?.currencyCode}}</td>
        </tr>
      </table>
    </div>

    <div class="parcode text-center" *ngIf="orderId && orderDetails.reciptQrCode">
      <img [src]="'data:image/png;base64,' + orderDetails.reciptQrCode" />
    </div>
    <div class="parcode text-center" *ngIf="!orderId">
      <img src="./assets/images/qrcode.png">
    </div>

    <div class="footer-sep"></div>

    <div class="diwan-data">
      <div class="img-card" *ngIf="config.ManagementSystemLogo?.isActive">
        <img [src]="config.ManagementSystemLogo.vaue || './assets/images/logos/logo.svg'" alt="">
      </div>
      <p class="font-14 font-medium text-center" *ngIf="config.Note?.isActive">{{ config.Note.value }}</p>
    </div>
  </div>
</div>
